import {ACCESS_TOKEN} from "../Const";
import {APP_WEB_WWW} from "../electron_interactive";
import {getCookies, isDevMode, isStringNullOrEmpty} from "../utils";
import {call} from "autoprefixer";

const request = (szMethod:string|'POST'|'GET'|'DELETE',szUrl:string,callback:any)=>{
    let szBaseUrl = isDevMode()?import.meta.env.VITE_DEV_HTTP_APP_BASE_URL:import.meta.env.VITE_HTTP_APP_BASE_URL;
    const xhr = new XMLHttpRequest();
    xhr.open(szMethod,szBaseUrl+szUrl,true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.setRequestHeader("Accept","application/json");
    xhr.responseType = "json"

    xhr.onreadystatechange = function (){
        if (xhr.readyState === 4 && xhr.status === 200){
            if (callback){
                callback(xhr.response);
            }
            console.log(xhr.response);
        }
    }

    let token = localStorage.getItem(ACCESS_TOKEN)
    if (APP_WEB_WWW && isStringNullOrEmpty(token)){
        token = getCookies()['token'];
    }
    //test
    if (import.meta.env.DEV){
        token = 'eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiIxMTQ6MTcyMjUyMzY2Njg4MSIsImV4cCI6MTcyMzM4NzY2Nn0.AhiN-0x32evoPWt8f2uC0DywSA4RVQV4dM_JkEjGvoMDmvOkD3ljYD4xqrF7yd2aZ3wYB5n5V6xTCtwnsDYhgw';
    }

    if (token) {
        xhr.setRequestHeader('access_token',token)
    }
    return xhr;
}

const jsonParamToQueryString = (jsonParams:any)=>{
    var queryString:any = Object.keys(jsonParams)
        .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(jsonParams[key]))
        .join('&');
    return queryString;
}

export const apiLibraryList = (isDeleted= 0,szType:string|'card'|'pdf'|'video'|'image'|'audio'|'file',szTagName:string,searchKey:string)=>{
    var jsonParams:any = {
        isDeleted,
        type:szType??'',
        tagName:szTagName??'',
        searchKey:searchKey??''
    }

    return new Promise((resolve, reject) => {
        const xhr = request("GET", '/library/list?'+jsonParamToQueryString(jsonParams),(res:any)=>{
            if (res.code == 0){
                resolve(res);
            }
        });
        xhr.send();
    })
}

/**
 * 更新library
 * @param card
 */
export const apiLibraryUpdate = (card:any)=>{
    return new Promise((resolve, reject) => {
        const xhr = request("POST", '/library/update',(res:any)=>{
            if (res.code == 0){
                resolve(res);
            }
        });
        xhr.send(JSON.stringify(card));
    })

}

/**
 * 获取详情....
 * @param szId
 */
export const apiLibraryDetail = (szId:string)=>{
    return new Promise((resolve, reject) => {
        const xhr = request("GET", '/library/detail?id='+szId,(res:any)=>{
            if (res.code == 0){
                resolve(res.data);
            }
        });
        xhr.send()
    })
}

/**
 * 删除卡片
 * @param szId
 */
export const apiLibraryDelete = (szId:string)=>{
    return new Promise((resolve, reject) => {
        const xhr = request("DELETE", '/library/delete?id='+szId,(res:any)=>{
            if (res.code == 0){
                resolve(res.data);
            }
        });
        xhr.send()
    })
}
